import type { ISO8601_DATE } from "../../../utils/iso8601";

export interface LibraryQuery {
  template_slug: string;
  program_slug: string;
}

export const isDiscoverTemplateQuery = (query: LibraryQuery): query is LibraryQuery =>
  "template_slug" in query && "program_slug" in query;

export interface Library {
  programs: LibraryProgram[];
}

export interface LibraryProgram {
  slug: string;
  name: string;
  photo?: string;
  color?: string;
  templates: LibraryTemplate[];
}

export interface LibraryTemplate {
  type: "moment";
  id: string;
  slug: string;
  title: string;
  what: string;
  context: string;
  img: LibraryTemplateImage;
  content: {
    email_subject: string;
    professional: string;
    casual: string;
    direct: string;
    custom?: string;
  };
  recommendations: {
    channel: string;
    send_time: string;
  };
  date: ISO8601_DATE | null;
  end_date: ISO8601_DATE | null;
  trigger: string | null;
  segment: LibrarySegment;
  trending: string | null;
  hero: boolean | null;
  top: number | null;
  geo: string | null;
  program: Omit<LibraryProgram, "templates">;
}

export type LibrarySegment =
  | "#general"
  | "All employees"
  | "All managers"
  | "Managers of All Employees"
  | "";

export interface LibraryTemplateImage {
  template_code: string;
  header?: string;
  subheader?: string;
  search?: string;
}
